import { Asociacion, AsociacionesService, Asociado, AsociadosService, Cargo, CargoAsociadoAsociacion, CargosService, Ejercicio, EjerciciosService, Historico, HistoricoService, PostRequestAsociado, TipoAsociacion, TipoAsociacionesService } from "../../../api";
import { HistoricoShow } from "../historico/historico.component";

export type BodyRequest = Asociacion | Asociado | Ejercicio | Cargo | TipoAsociacion | Historico | PostRequestAsociado | CargoAsociadoAsociacion | HistoricoShow;

export type ServiceRequest = AsociacionesService | AsociadosService | EjerciciosService | CargosService | TipoAsociacionesService | HistoricoService;

export enum ServicesAvailable {
    AsociacionesService = 'AsociacionesService',
    AsociadosService = 'AsociadosService',
    EjerciciosService = 'EjerciciosService',
    CargosService = 'CargosService',
    TipoAsociacionesService = 'TipoAsociacionesService',
    HistoricoService = 'HistoricoService'
  }
  
  export enum ItemType {
    ASOCIACIONES = 'Asociaciones',
    ASOCIADOS = 'Asociados',
    EJERCICIOS = 'Ejercicios',
    CARGOS = 'Cargos',
    TIPOASOCIACIONES = 'TipoAsociaciones',
    HISTORICO = 'Historico',
    POSTREQUESTASOCIADO = 'PostRequestAsociado',
    CARGOASOCIADOASOCIACION = 'CargoAsociadoAsociacion',
    HISTORICOASOCIADO = 'HistoricoAsociado'
  }

  export const ServicesForm: { [key in ItemType]: string } = {
    [ItemType.ASOCIACIONES]: 'asociacionesService',
    [ItemType.ASOCIADOS]: 'asociadosService',
    [ItemType.EJERCICIOS]: 'ejerciciosService',
    [ItemType.CARGOS]: 'cargosService',
    [ItemType.TIPOASOCIACIONES]: 'tipoAsociacionesService',
    [ItemType.HISTORICO]: 'historicoService',
    [ItemType.POSTREQUESTASOCIADO]: 'asociadosService',
    [ItemType.CARGOASOCIADOASOCIACION]: 'cargosService',
    [ItemType.HISTORICOASOCIADO]: 'asociadosService'
  };

export enum FunctionsAvailable {
  asociacionesPost = 'asociacionesPost',
  asociadosPost = 'asociadosPost',
  ejerciciosPost = 'ejerciciosPost',
  cargosPost = 'cargosPost',
  tipoasociacionesPost = 'tipoasociacionesPost',
  historicoPost = 'historicoPost',

  asociacionesPut = 'asociacionesPut',
  asociadosPut = 'asociadosPut',
  ejerciciosPut = 'ejerciciosPut',
  cargosPut = 'cargosPut',
  tipoasociacionesPut = 'tipoasociacionesPut',
  historicoPut = 'historicoPut',
}